export default __webpack_public_path__ + "static/media/B0004.2a8977d0.png";